var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingPanel',{attrs:{"title":"Additional ticket types"},scopedSlots:_vm._u([{key:"edit",fn:function(ref){
var done = ref.done;
return [_c('TicketTypeManagement',{attrs:{"value":_vm.selectedBot.ticket_v3_config},on:{"close":function($event){return done()}}})]}}])},[_vm._v("\n\n  "+_vm._s(_vm.text || '-')+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58929676","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/ticket3/ticket-management/Setting/TicketType.vue
// module id = null
// module chunks = 